import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Button, Box, Typography, Avatar, Paper } from "@mui/material";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import { alert } from "../../redux/slices/alertSlice";
import Logo from "../../assets/auth carousel pics/verismart-background.png";

// Brand colors
const colors = {
  green: "#28967e",
  purple: "#8f1c82",
  blue: "#028fd1",
  yellow: "#f3b61f",
};

// Styled components
const Container = styled(Box)`
  min-height: 100vh;
  background: linear-gradient(135deg, ${colors.purple}, ${colors.blue});
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const Card = styled(Paper)`
  padding: 40px;
  max-width: 500px;
  text-align: center;
  border-radius: 20px;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.1);
`;

const StyledButton = styled(Button)`
  background-color: ${colors.green};
  color: white;
  margin-top: 24px;
  padding: 12px 28px;
  font-size: 16px;
  border-radius: 8px;
  &:hover {
    background-color: #207c68;
  }
`;

const HeaderAvatar = styled(Avatar)`
  background-color: ${colors.yellow};
  width: 70px;
  height: 70px;
  margin: 0 auto 20px auto;
`;

const LogoIcon = styled("img")`
  width: 160px;
  margin-bottom: 20px;
`;

export default function Form({ code }) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Container>
      <Card elevation={4}>
        <LogoIcon src={Logo} alt="CashKaro Logo" />

        <HeaderAvatar>
          <EmailIcon fontSize="large" sx={{ color: "#fff" }} />
        </HeaderAvatar>

        <Typography variant="h5" fontWeight="bold" gutterBottom>
          You are almost there!
        </Typography>

        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
          Welcome to the CashKaro Ad Tech Platform!
        </Typography>

        <Typography variant="body1" sx={{ marginTop: 2 }}>
          Please click the button below to verify your email account and proceed
          to the next steps. We’re excited to have you with us!
        </Typography>

        <StyledButton
          onClick={handleVerify}
          variant="contained"
          endIcon={<CheckCircleIcon />}
        >
          Verify Email
        </StyledButton>
      </Card>
    </Container>
  );
  function handleVerify() {
    axios({
      url: "/user/verifyEmail",
      method: "POST",
      data: {
        code: code,
      },
    }).then((res) => {
      if (res.status) {
        dispatch(
          alert({
            type: "success",
            message: res.message.displayMessage,
          })
        );
        navigate(pages.signIn.route);
      }
    });
  }
}
